import "core-js/stable";
import "regenerator-runtime/runtime";

require("turbolinks").start();
require("stylesheets/promo.scss");

// console.log("Hello World from Webpacker");

const images = require.context("../images", true);
const imagePath = (name) => images(name, true);

import "controllers";
